import { ModalService } from '@dmp/components/ui/ModalService/ModalService';
import { appMeta, getLatestBuildTime } from '@dmp/config';

export const displayNewVersionWarning = async () => {
  ModalService.warning({
    title: 'New version is available, please refresh the page',
    onOk: () => {
      window.location.reload();
    },
    persistent: true,
  });
};

export const checkIsNewVersionReleased = async () => {
  const latestBuildTime = await getLatestBuildTime();

  return latestBuildTime !== appMeta.buildTime;
};

export const checkNewVersion = async () => {
  const isNewVersionReleased = await checkIsNewVersionReleased();
  if (isNewVersionReleased) {
    displayNewVersionWarning();
  }
};
